<template>

    <v-snackbar
        v-model="snackbarShow"
        :color="snackbarColor"
        :centered="snackbarCentered"
        :top="snackbarTop"
        rounded="pill"
        elevation="24"
        shaped

    >
        <div class="subtitle-1">

            <v-icon v-if="isSuccess" v-text="icons.mdiCheckCircle" class="mx-2" :size="24"></v-icon>
            <v-icon v-else-if="isError" v-text="icons.mdiCloseCircle" class="mx-2" :size="24"></v-icon>

            <span class="pl-2 font-weight-bold" v-html="snackbarText"></span>

        </div>

        <template v-slot:action="{ attrs }">
            <v-btn
                color="secondary"
                text
                v-bind="attrs"
                @click="snackbarShow = false"
            >
                Okay
            </v-btn>
        </template>
    </v-snackbar>

</template>

<script>
import MixinIcon from '@/mixins/MixinIcon'

export default {
    name: 'SnackBar',
    data() {
        return {
            snackbarShow: false,
            snackbarText: '',
            snackbarColor: 'secondary',
            snackbarCentered: false,
            snackbarTop: false,
        }
    },
    mixins: [MixinIcon],

    computed: {
        isSuccess() {

            let self = this
            let successKeywords = ['success', 'OK', 'saved']
            let foundSuccessKeyword

            successKeywords.forEach(keyword => self.snackbarText.toLowerCase().includes(keyword.toLowerCase()) ? foundSuccessKeyword = true : false)

            return foundSuccessKeyword

        },
        isError() {
            let self = this
            return (self.snackbarText.toLowerCase().includes('sorry') || self.snackbarText.toLowerCase().includes('error') || self.snackbarText.toLowerCase().includes('invalid'))
        }
    }
    ,
    methods: {
        /**
         *
         * @param text
         * @param icon The icon of the popup can be: warning, error, success, info, and question. It can either be put in the array under the key "icon" or passed as the third parameter of the function.
         * @param position - Popup window position, can be 'top', 'top-start', 'top-end', 'center', 'center-start', 'center-end', 'bottom', 'bottom-start', or 'bottom-end'.
         * @param timer
         * @param confirmation { callback: function, showCancelButton: boolean, confirmButtonText: string, cancelButtonText: string}
         *
         */
        showSnackbar(text, icon = 'success', position = 'bottom-end', timer = 3000, confirmation = false) {
            /*
            this.snackbarText = text
            this.snackbarShow = true
            this.snackbarColor = color

            if (typeof text === 'string' && text.indexOf('error') !== -1) {
                this.snackbarColor = 'red'
            }

            if (direction === 'center') {
                this.snackbarCentered = true
            } else if (direction === 'top') {
                this.snackbarTop = true
            }
            */

            let options = {
                toast: true,
                position: position,
                showConfirmButton: false,
                timer,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }

            if (confirmation) {
                options.showConfirmButton = true
                options.showCancelButton = confirmation.showCancelButton ? confirmation.showCancelButton : false
                options.confirmButtonText = confirmation.confirmButtonText ? confirmation.confirmButtonText : 'Yes'
                options.cancelButtonText = confirmation.cancelButtonText ? confirmation.cancelButtonText : 'No'
            }

            const Toast = this.$swal.mixin(options)

            Toast.fire({
                icon: icon,
                html: text,
                position: 'bottom'
            }).then((result) => {

                if (confirmation && result.isConfirmed && typeof confirmation.callback === 'function') {
                    confirmation.callback()
                }

            })

        },

        hideSnackbar() {
            let self = this

            self.$swal.close()
        }
    }
    ,
}
</script>
